// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2Iz0o","tab":"Tabs_tab__1jijd","tabActive":"Tabs_tabActive__17QYM"};